import React, { useState, useEffect } from 'react';

import Container from 'react-bootstrap/Container';
import Carousel from 'react-bootstrap/Carousel';

import { RiDoubleQuotesR } from "react-icons/ri";


export default function Testimonials(){
    
    return (
        <section>
            <Container>                   
                <Carousel className="p-5 text-center">
                    <Carousel.Item>
                        <div>
                        <i className="icon_button text-white d-inline-block mb-4    "><RiDoubleQuotesR /></i>
                        <h3>“Great Designer, does great work and is very flexible with change. if you’re a programmer and are looking for UI/UX designer is definitely well qualified for the job.”</h3>
                        <div><h6 className="d-inline-block text-uppercase">James Quincey</h6><p className="d-inline-block text-muted ms-3">CEO of Google</p></div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div>
                        <i className="icon_button text-white d-inline-block mb-4    "><RiDoubleQuotesR /></i>
                        <h3>“Great Designer, does great work and is very flexible with change. if you’re a programmer and are looking for UI/UX designer is definitely well qualified for the job.”</h3>
                        <div><h6 className="d-inline-block text-uppercase">James Quincey</h6><p className="d-inline-block text-muted ms-3">CEO of Google</p></div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div>
                        <i className="icon_button text-white d-inline-block mb-4    "><RiDoubleQuotesR /></i>
                        <h3>“Great Designer, does great work and is very flexible with change. if you’re a programmer and are looking for UI/UX designer is definitely well qualified for the job.”</h3>
                        <div><h6 className="d-inline-block text-uppercase">James Quincey</h6><p className="d-inline-block text-muted ms-3">CEO of Google</p></div>
                        </div>
                    </Carousel.Item>
                </Carousel>
                <p>Sed elementum pellentesque nibh, auctor varius felis ornare euismod. Etiam in purus ac ipsum placerat imperdiet eu lacinia quam. Aliquam vel scelerisque quam. In suscipit massa non elementum commodo. Nullam id mi pellentesque, tempus mauris quis, egestas arcu. In condimentum mollis purus vitae egestas. Donec consectetur, felis et semper fermentum, eros orci egestas mauris, at imperdiet justo erat vel quam. Aliquam at risus nec augue molestie consectetur eget sit amet mauris. Mauris a lectus varius, dignissim nulla quis, commodo justo. Donec ornare condimentum arcu sit amet feugiat. Interdum et malesuada fames ac ante ipsum primis in faucibus. Donec venenatis mauris at sapien ultricies, sit amet pellentesque arcu imperdiet. Nulla venenatis vel lectus interdum elementum.</p>
            </Container>
        </section>
    )
}